/****************************************************************************************
 * File Name    : Safety.vue
 * Function     :
 * Author       : 최명호
 * Tester       :
 * Page         :
 * Target       :
 * Description  :
 * Modification Log
 * ======================================================================================
 * Ver  Date        	Author     	Modification
 * ======================================================================================
   1.0  2021.04.16  	최명호    	Create
****************************************************************************************/
<template>
    <div class="">
        <div v-if = "flagSpinner === false">
            <a-row :gutter="16">
                <a-col class="gutter-row" :span="24">
                    <div class="gutter-box">
                        <PageHeader title = "안전보건점검일지 등록" />
                    </div>
                </a-col>
            </a-row>
            <a-divider type = 'horizontal' />
            <a-space align="end" style="padding-top:10px;">
                <a-radio-group  v-model="filterState">
                    <a-radio-button @click="changeFilterState('등록중')" value="등록중">등록중</a-radio-button>
                    <a-radio-button @click="changeFilterState('등록완료')" value="등록완료">등록완료</a-radio-button>
                    <a-radio-button @click="changeFilterState('모두')" value="모두">모두보기</a-radio-button>
                </a-radio-group>
                <div class="custom-input-group" style="display: inline-flex; align-items: stretch; margin-left: 5px;">
                    <a-input placeholder="검색어 입력" v-model="filterCS" />
                    <select class="native-select filter-select" v-model="filterField" style="min-width: 100px; margin-left: -1px; border-top-left-radius: 0; border-bottom-left-radius: 0;">
                        <option value="category">관리구분</option>
                        <option value="title">제목</option>
                    </select>
                </div>
                <a-button type="primary" ghost="true" @click="filterCSList">검색</a-button>
                <a-button @click="resetCSList">초기화</a-button>
                <a-divider type = 'vertical' />
                <div class="border:1px solid red;width:100%">
                    <router-link to="/safetyProduct">
                        <a-button type="primary" icon="plus-circle" size = "default" >
                            일지 생성하기
                        </a-button>
                    </router-link>
                </div>
            </a-space>
            <p/>
            <a-progress type = 'line' :percent="validRate" strokeColor = '#C7C6C6'/>
            <p/>
            <div class = 'todo'>검색필터 등 추가. 현재는 '완료'상태만 표시됨. pagination 추가</div>
            <a-table :columns="columns" size = "small" :bordered=false :data-source="data" :pagination="pagination" :scroll="{ x: 0, y: '57vh' }" @change="handleTableChange">
                <span slot="tags" slot-scope="tag">
                    <a-tag class="state-btn" :class="{ red: (tag === '등록중'), green: (tag === '등록완료') }">
                        {{ tag.toUpperCase() }}
                    </a-tag>
                </span>
                <span slot="name" slot-scope="text">{{ text }}</span>
                <span slot="action" slot-scope="record">
                    <span style = 'cursor:pointer' @click="handlerToCreateProductCS(record)"><a-icon type="save" /> Edit</span>
                    <!-- <span style = 'cursor:pointer'><a-icon type="edit" /> Edit</span> -->
                    <a-divider type="vertical" />
                    <span style = 'cursor:pointer' @click="handlerToDeleteProductCS(record)"><a-icon type="delete" /> Delete</span>
                    <a-divider type="vertical" />
                    <span style = 'cursor:pointer' @click="handlerToViewProductCS(record)"><a-icon type="eye" /> view</span>
                    <a-divider type="vertical" />
                    <span style = 'cursor:pointer' @click="goToHistoryList(record)"><a-icon type="history" /> 개정 이력 관리</span>
                </span>
            </a-table>
        </div>
        <a-skeleton v-else />
        <a-drawer title="" placement="right" :closable="false" :visible="flagForDrawer" @close="handlerForCloseDrawer" width="50vw" >
            <SafetyViewer :target = "target" v-on:flagForDrawer="handlerForCloseDrawer" />
        </a-drawer>
    </div>
</template>
<script>
import PageHeader from "../components/PageHeader.vue";
import SafetyViewer from "./SafetyViewer.vue";
import _ from "lodash";

// state 값
// 초/중/종품 등록중 - A
// 초/중/종품 등록완료 - B
// 초/중/종품 검사중 - C
// 초/중/종품 검사완료 - D
// 공정순회 등록중 - E
// 공정순회 등록완료 - F
// 공정순회 검사중 - G
// 공정순회 검사완료 - H

const columns = [
    {    title: '상태' , dataIndex: 'tag' , key: 'tag' , scopedSlots: { customRender: 'tags' }, width : 100},
    {    title: '관리구분' , dataIndex: 'category' , key: 'category' , scopedSlots: { customRender: 'category' }, width : 150},
    {    title: '제목' , dataIndex: 'title' , key: 'title' , scopedSlots: { customRender: 'title' }, width : 350},
    {    title: '등록일' , dataIndex: 'updated' , key: 'updated' , scopedSlots: { customRender: 'name' }, width : 200},
    {    title: '관리' , key: 'action' , scopedSlots: { customRender: 'action' }, width : 250},
];
export default {
    name: 'Safety',
    components: {
        PageHeader,
        SafetyViewer,
    },
    data() {
        return {
            flagSpinner : false,
            data: [],
            dataBackup: [],
            columns,
            dataArray : [],
            dataArrayAll: [], // 전체 데이터 저장
            total : 0,
            valid : 0,
            suspended : 0,
            validRate : 0,
            suspendedRate : 0,
            flagForDrawer: false,
            dataOffset : 0,
            filterState : '모두',
            filterCS : '',
            filterField: 'category',
            target: null,
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                showSizeChanger: true,
                showTotal: (total, range) => `${range[0]}-${range[1]} / ${total}개`
            }
        };
    },
    mounted() {
        this.loadProducCSStattistics();
    },
    methods : {
        loadProducCSStattistics() {
            this.flagSpinner = true;
            let urlToFetchProductCSStat = this.$store.state.hostInService + "/product/cs/statistics";
            this.$http.get(urlToFetchProductCSStat)
            .then((response) => {
                if(response.status === 200 && response.data.code === 'success') {
                    let dataObject = response.data.data;
                    this.valid = dataObject.valid;
                    this.suspended = dataObject.suspended;
                    this.total = this.valid + this.suspended;
                    this.validRate = Number((this.valid/this.total)*100).toFixed(0)*1;
                    this.validSuspended = Number((this.valid/this.total)*100).toFixed(0)*1;
                    // DESC : 리스트를 조회한다.
                    this.fetchProductCSList('', 1, this.pagination.pageSize);
                }
            }).catch(error => {
                console.log(error);
                this.flagSpinner = false;
            });
        },
        fetchProductCSList(queryStr, page = 1, pageSize = 10) {
            this.dataArray = [];
            this.data = [];
            this.flagSpinner = true;

            // 효율적인 페이지네이션 방식으로 변경
            let url = `${this.$store.state.nodeApiUrl}/product/cs/list_simple_checksheet_safety?size=${pageSize}&page=${page - 1}`;
            
            // 검색 쿼리가 있는 경우 추가
            if (queryStr) {
                url += queryStr;
            }
            
            // 검색어 추가
            if (this.filterCS) {
                if (this.filterField === 'category') {
                    url += `&category=${encodeURIComponent(this.filterCS)}`;
                } else if (this.filterField === 'title') {
                    url += `&title=${encodeURIComponent(this.filterCS)}`;
                }
            }
            
            this.$http.get(url)
                .then((response) => {
                    if (response.status === 200 && response.data.code === 'success') {
                        // 페이지네이션 정보 업데이트
                        this.pagination.total = response.data.data.totalElements || 0;
                        this.pagination.current = page;
                        this.pagination.pageSize = pageSize;
                        
                        // 서버에서 받은 데이터를 직접 사용 (S, T 상태만 필터링)
                        this.dataArray = _.filter(response.data.data.content, (item) => {
                            return item.state === 'S' || item.state === 'T';
                        });
                        
                        // 상태 필터 적용
                        let filtered = this.dataArray;
                        if (this.filterState === '등록중') {
                            filtered = filtered.filter(item => item.state === 'S');
                        } else if (this.filterState === '등록완료') {
                            filtered = filtered.filter(item => item.state === 'T');
                        }
                        
                        // 테이블 데이터 가공
                        this.processTableData(filtered);
                    }
                    this.flagSpinner = false;
                })
                .catch(() => {
                    this.flagSpinner = false;
                });
        },
        processTableData(filtered) {
            // 테이블 데이터 가공
            this.data = filtered.map((item, x) => {
                let tag = item.state === 'S' ? '등록중' : '등록완료';
                let updatedObj = new Date((new Date(item.updated)).getTime() + 0 * 60 * 60 * 1000);
                let year = updatedObj.getFullYear();
                let month = (updatedObj.getMonth() + 1).toString().padStart(2, '0');
                let date = updatedObj.getDate().toString().padStart(2, '0');
                return {
                    key: x,
                    name: item.name,
                    tag: tag,
                    updated: `${year}-${month}-${date}`,
                    model: item.clsProduct?.productModel,
                    modelDetail: item.clsProduct?.productModelDetail,
                    product: item.clsProduct?.productName,
                    category: item.category,
                    title: item.title,
                    target: item.target,
                    productCsSeq: item.productCsSeq
                };
            });
        },
        handlerToViewProductCS(record) {
            let target = record;
            let urlToFetchProductCSList = this.$store.state.nodeApiUrl + "/product/cs/get_safety_cs_item?seq=" + target.productCsSeq;
                this.$http.get(urlToFetchProductCSList)
                .then((response) => {
                    if(response.status === 200 && response.data.code === 'success') {
                        let item = response.data.data.content[0];
                        item.listProductCSInpection = _.orderBy(item.listProductCSInpection, 'produtCsInspectionSeq');
                        this.dataArray[target.key] = item;
                        this.target = item;
                        this.flagForDrawer = true;         
                    }
                });
        },
        handlerToCreateProductCS(record) {
            let target = record;

            // 필터 데이터 조회
            this.$http.get(this.$store.state.nodeApiUrl + '/product/cs/get_safety_data?productCsSeq=' + target.productCsSeq)
                .then((response2) => {
                    if(response2.status === 200 && response2.data.code === 'success') {
                        console.log('get_safety_data', response2.data.data.content[0])

                        let urlToFetchProductCSList = this.$store.state.nodeApiUrl + "/product/cs/get_safety_cs_item?seq=" + target.productCsSeq;
                        this.$http.get(urlToFetchProductCSList)
                        .then((response) => {
                            if(response.status === 200 && response.data.code === 'success') {
                                let item = response.data.data.content[0];

                                item.safetyData = response2.data.data.content[0];

                                this.$router.push({ name: 'SafetyProduct', params: { editCS: item } });            
                            }
                        });
                    }
                });
        },
        handlerForCloseDrawer() {
            this.flagForDrawer = false;
        },
        handlerToSaveCSForProudct(listItem) {

            console.log(listItem)

            let generatedObjectToPersist = {
                productSeq: listItem.clsProduct.productSeq,
                productCSName: 'SAFETYCS-' + listItem.name,
                productCSInspections: [],
                productCSTimes: []
            };

            _.forEach(listItem.listProductCSInpection, (item) => {
                let obj = {
                    index: '' + item.inspectionIndex,
                    offset: '' + item.inspectionOffset,
                    inspection: item.inspectionName,
                    inspectionTarget: item.inspectionTarget || '',
                    standard: {
                        min: item.listProductCSInpectionStandard.length && item.listProductCSInpectionStandard[0].min || '',
                        max: item.listProductCSInpectionStandard.length && item.listProductCSInpectionStandard[0].max || '',
                        name: item.listProductCSInpectionStandard.length && item.listProductCSInpectionStandard[0].name || '',
                        result: item.listProductCSInpectionStandard.length && item.listProductCSInpectionStandard[0].result || ''
                    },
                    imageSeq: item.inspectionImageSeq,
                    image2Seq: 0,
                    description: item.inspectionDescription
                };

                generatedObjectToPersist.productCSInspections.push(obj);
            });

            _.forEach(listItem.listProductCSTime, (item) => {
                let obj = {
                    start: item.timeStart,
                    terms: item.timeTerms
                };

                generatedObjectToPersist.productCSTimes.push(obj);
            });


            let urlForProduct = this.$store.state.hostInService + '/product/cs/add';
            this.$http.post(urlForProduct,generatedObjectToPersist)
            .then((response) => {
                if (response.status === 200 && response.data.code === 'success') {
                    this.$message.success('등록되었습니다');
                    this.fetchProductCSList();
                }  else {
                    this.$message.error('등록되지 않았습니다(1).');
                }
            })
            .catch(error => {
                console.error(error);
                this.$message.error('등록되지 않았습니다(2).');
            });
        },
        handlerToDeleteProductCS(record) {
            if (confirm('삭제하시겠습니까?')) {
                let urlForProduct = this.$store.state.hostInService + '/product/cs/delete';
                let listItem = record;
                let generatedObjectToPersist = {
                    productCsSeq: listItem.productCsSeq
                };
                this.$http.put(urlForProduct,generatedObjectToPersist)
                    .then((response) => {
                        if (response.status === 200 && response.data.code === 'success') {
                            this.$message.success('삭제되었습니다');
                            this.fetchProductCSList();
                        }  else {
                            this.$message.error('삭제되지 않았습니다(1).');
                        }
                    })
                    .catch(error => {
                        console.error(error);
                        this.$message.error('삭제되지 않았습니다(2).');
                    });
            }
        },
        changeFilterState(state) {
            this.filterState = state;
            this.pagination.current = 1;
            this.fetchProductCSList('', 1, this.pagination.pageSize);
        },
        filterCSList() {
            this.pagination.current = 1;
            this.fetchProductCSList('', 1, this.pagination.pageSize);
        },
        handleTableChange(pagination) {
            this.pagination.current = pagination.current;
            this.pagination.pageSize = pagination.pageSize;
            this.fetchProductCSList('', pagination.current, pagination.pageSize);
        },
        resetCSList() {
            this.filterCS = '';
            this.filterState = '모두';
            this.filterField = 'category';
            this.pagination.current = 1;
            this.fetchProductCSList('', 1, this.pagination.pageSize);
        },
        // 개정 이력 관리 페이지로 이동하는 메서드 추가
        goToHistoryList(record) {
            const target = record;
            this.$router.push({
                path: `/safetyHistoryList/${target.productCsSeq}`
            });
        }
    }
}
</script>
<style scoped>
    .div_list_footer {
        text-align: center;
    }
    
    .native-select {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        background-color: #fff;
        border: 1px solid #d9d9d9;
        border-radius: 2px;
        box-sizing: border-box;
        color: rgba(0, 0, 0, 0.65);
        cursor: pointer;
        display: inline-block;
        font-size: 14px;
        font-weight: 400;
        height: 32px;
        line-height: 32px;
        min-width: 0;
        outline: none;
        padding: 0 11px;
        position: relative;
        transition: all 0.3s;
        background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2212%22%20viewBox%3D%220%200%2012%2012%22%3E%3Cpath%20fill%3D%22%23595959%22%20d%3D%22M6%208L2%204h8z%22%2F%3E%3C%2Fsvg%3E");
        background-repeat: no-repeat;
        background-position: right 8px center;
        padding-right: 24px;
    }
    
    .native-select:hover {
        border-color: #40a9ff;
    }
    
    .native-select:focus {
        border-color: #40a9ff;
        box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
        outline: 0;
    }
    
    .filter-select {
        min-width: 100px;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
    
    .custom-input-group {
        display: inline-flex;
        align-items: stretch;
    }
</style>